import { Box, Button, styled } from "@mui/material";
import { gaugeClasses } from "@mui/x-charts";
import { Colors } from "../theme";
import { borderRadius, transitions } from "polished";
import { NoEncryption } from "@mui/icons-material";
export const CourseContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  "& button": {
    fontSize: "12px",
  },
  "& .font12": {
    fontSize: "12px",
  },
  "& .font14": {
    fontSize: "14px",
  },
  "& .header-section": {
    display: "flex",
    gap: "10px",
    backgroundColor: Colors.white,
    justifyContent: "left",
    alignItems: "center",
    padding: "10px",
  },
  "& .course-section": {
    display: "grid",
    gridTemplateColumns: "repeat(3,1fr)",
    gridGap: "30px 10px ",
    "@media (max-width: 1216px)": {
      gridTemplateColumns: "repeat(2, 1fr)",
    },
    "@media (max-width: 900px)": {
      gridTemplateColumns: "repeat(1, 1fr)",
    },
    "& .course-card": {
      minWidth: "350px",
      border: "1px solid" + Colors.border,
      borderRadius: "19px",
      display: "flex",
      flexDirection: "column",
      padding: "20px",
      boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
      marginBottom: "10px",
      "& .course-image": {
        width: "100%",
        marginBottom: "5px",
        overflow: "hidden",
        "& img": {
          width: "100%",
          aspectRatio: "16 / 9",
          borderRadius: "9px",
          transition: "0.2s ease-in-out",
        },
      },

      "&  .course-content": {
        paddingTop: "10px",
        "& h3": {
          fontSize: "16px",
          fontWeight: 500,
          marginBottom: "5px",
        },
        "& p": {
          fontSize: "14px",
          color: Colors.garyText,
          marginBottom: "10px",
        },

        "&  .course-actions": {
          padding: "0px 10px 0 0",
          marginTop: "10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          "& .piechart": {
            maxWidth: "70px",
            maxHeight: "70px",
            overflow: "hidden",
            [`& .${gaugeClasses.valueArc}`]: {
              fill: Colors.primary,
            },
            "& svg": {
              fill: Colors.primary,
              height: "70px",
              width: "70px",
              viewBox: "0 0 70 70",
              preserveAspectRatio: "xMidYMid meet",
            },
          },
        },
        "& .flex-card": {
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        },
        "& .flex-card .details ": {
          display: "flex",
          flexDirection: "column",
          gap: "10px",
        },
      },
    },
  },
  "& a": {
    textDecoration: "none",
  },
}));

export const StyledButton = styled(Button)({
  backgroundColor: Colors.primary,
  color: Colors.text,
  borderRadius: "5px",
  textTransform: "none",
  padding: "5px 10px",
  display: "flex",
  alignItems: "center",
  gap: "5px",
  border: "1px solid" + Colors.border,

  boxShadow: "none",

  "&:hover": {
    backgroundColor: Colors.hover,
    boxShadow: "none",
  },
  " & .icon": {
    height: "20px",
  },
});

export const DetailedCourseContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  padding: "0 10px",
  width: "100%",
  "@media (max-width: 900px)": {
    padding: "0 0",
  },
  "& .title": {
    fontSize: "22px",
    fontWeight: 500,
    marginBottom: "10px",
    "@media (max-width: 900px)": {
      fontSize: "18px",
      marginBottom: "5px",
    },
  },

  "& .module-title , .exam-title": {
    fontSize: "14px",
    fontWeight: 500,
    color: Colors.black,
    "@media (max-width: 900px)": {
      fontSize: "14px",
    },
  },
  "& .module-description": {
    fontSize: "14px",
    margin: " 0 0 10px 0",
  },
  "& .course-preview": {
    display: "grid",
    gridTemplateColumns: "350px auto",
    width: "100%",
    gridGap: "20px",
    position: "relative",
    [theme.breakpoints.down("md")]: {
      gridTemplateColumns: "1fr",
    },

    "& .course-media": {
      position: "sticky",
      top: "80px",

      // border:"1px solid black",
      width: "100%",
      height: " calc(100vh - 120px)",
      [theme.breakpoints.down("sm")]: {
        position: "static",
        height: "fit-content",
      },
      "&::-webkit-scrollbar": {
        width: "5px",
      },
      "&::-webkit-scrollbar-track": {
        WebkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "rgba(0, 0, 0, 0.2)",
      },

      "& .media-container": {
        width: "100%",
        "& iframe": {
          height: "100vh",
        },
      },
    },
    "& .course-modules": {
      overflowY: "auto",
      width: "350px",
      "@media (max-width: 900px)": {
        width: "100%",
        order: 2,
      },
    },
    "& .module-header.incomplete": {
      backgroundColor: "hsl(40, 100.00%, 91.00%)",
    },
    "& .module-header.completed": {
      backgroundColor: "hsl(138, 100.00%, 91.60%)",
    },
    "& .module-accordion.active , .submodule-accordion.active": {
      borderLeft: "4px solid  " + Colors.primary,
    },
    "& .module-accordion ": {
      marginBottom: "5px",
      backgroundColor: Colors.white,
      border: "1px solid " + Colors.border,
      borderRadius: "5px",
      boxShadow: "none",
      transitions: ".2s all linear",
      "& .module-header": {
        borderRadius: "4px",

        "&:hover": {
          opacity: "0.8",
        },
        "& .module-index": {
          fontWeight: 500,
        },
      },
      "& .module-header-active , .submodule-header-active": {
        borderBottom: `1px solid ${Colors.border}`,
      },
    },
    "& .module-details": {
      padding: "10px 16px",
      maxHeight: "none",
    },
    "& .submodule-accordion , .exam-accordion": {
      marginBottom: "10px",
      borderRadius: " 3px 0px 0px 3px",
      backgroundColor: `#F7F7F7`,

      border: "1px solid " + Colors.border,
      borderRadius: "5px",
      boxShadow: "none",
      "&::before": {
        backgroundColor: "transparent",
      },

      "& .submodule-header , .exam-header": {
        borderRadius: "4px",
        "&:hover": {
          backgroundColor: Colors.text,
        },
      },
      "& .submodule-details": {
        flexDirection: "column",
        "& .submodule-content": {
          display: "flex",
          gap: "20px",
          [theme.breakpoints.down("md")]: {
            flexDirection: "column",
            gap: "0px",
          },
        },
      },
      "& .file-button": {
        padding: "0px",
      },
      "& .media-file , .exam-description": {
        cursor: "pointer",
        "& .media-icon": {
          color: Colors.primary,
        },
        border: "1px solid " + Colors.border,
        borderRadius: "5px",
        padding: "0 10px",
        display: "flex",
        alignItems: "center",
        gap: "10px",
        backgroundColor: Colors.white,
        "& a": {
          width: "100%",
          fontSize: "14px",
          color: Colors.garyText,
          padding: "10px",
          textDecoration: "none",
        },
        "&:hover": {
          backgroundColor: Colors.text,
        },
      },
    },
  },
}));
